import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Home from "../views/Home.vue";
import contactUs  from "../views/contactUs";
import ourName  from "../views/ourName";
import ourVision  from "../views/ourVision";
import login      from  "../views/login";
import breakfast      from  "../views/breakfast"
import launch      from  "../views/launch"
import dinner      from  "../views/dinner"
import fullMenu      from  "../views/fullMenu"
import registration from  "../views/registration"
import Dashboard      from  "../views/Dashboard"
import updateMenu      from  "../views/updateMenu"
import upload      from  "../views/upload"
import upload_text      from  "../views/upload_text"
import update_text      from  "../views/update_text"
import updateTextCard   from  "../components/updateTextCard"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/updateMenu",
    name: "updateMenu",
    props: true,
    component: updateMenu,
    meta: {
      requiredAuth: true
    }
  },

  {
    path: "/updateTextCard",
    name: "updateTextCard",
    props: true,
    component: updateTextCard,
    meta: {
      requiredAuth: true
    }
  },

  {
    path: "/upload_text",
    name: "upload_text",
    component: upload_text,
    meta: {
      requiredAuth: true
    }
  },

  {
    path: "/update_text",
    name: "update_text",
    component: update_text,
    meta: {
      requiredAuth: true
    }
  },
  {
    path: "/registration",
    name: "registration",
    component: registration,
    meta: {
      requiredAuth: true
    }
  },
  {
    path: "/launch",
    name: "launch",
    component: launch
  },
  {
    path: "/dinner",
    name: "dinner",
    component: dinner
  },
  {
    path: "/fullMenu",
    name: "fullMenu",
    component: fullMenu
  },
  {
    path: "/breakfast",
    name: "breakfast",
    component: breakfast
  },
  {
    path: "/upload",
    name: "upload",
    component: upload,
    meta: {
      requiredAuth: true
    }
  },

  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiredAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs
  },
  {
    path: "/ourName",
    name: "ourName",
    component: ourName
  },
  {
    path: "/ourVision",
    name: "ourVision",
    component: ourVision
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next ) => {
  if(to.matched.some(record => record.meta.requiredAuth)) {
    if(!store.getters.isLogedIn){
      //Not Authorized user trying to login protected page, redirect to the login page 
      next('/login');
    } else {
      next();
    }
  } else {
    next()
  }
})

export default router;
